import * as $ from "jquery"
import { App } from "../../_app";
import { Resources } from "../resources";
import { AjaxServiceResponse } from "../service-response";
import { Functions } from "./_functions";

interface IValidateLicensePlateData {
    __RequestVerificationToken: string,
    licensePlate: string,
    countryCode: string,
    isZba: boolean
}

export interface IValidatePlateResponseData {
    IsValid: boolean;
    RegexType: LicensePlateRegexType;
    IsInZba: boolean;
    PreviewBackgroundImageUrl: string,
    GraphicRegistrationNumberImageUrl: string,
    TextBefore: string,
    TextAfter: string
}

export enum LicensePlateRegexType {
    Standard = 1,
    Special = 2,
    Custom = 3
}

interface UnobtrusiveValidationValidator extends MicrosoftJQueryUnobtrusiveValidation.Validator {
    options: JQueryValidation.ValidationOptions
}

//App.Common.Functions.Validation
export class Validation {
    private static errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegEx;
    private static lastData: IValidateLicensePlateData = null;
    private static lastResult: AjaxServiceResponse<IValidatePlateResponseData> = null;

    public static ValidatorSettings: JQueryValidation.ValidationOptions = {
        onkeyup: false,
        errorClass: "input-validation-error",
        errorElement: "div",
        ignore: ".ignore-validation",
        errorPlacement: function (error: JQuery<HTMLElement>, element: JQuery<HTMLFormElement>) {
            if (element.hasClass("selectpicker") || element.hasClass("datepicker")) {
                error.insertAfter(element.parent());
            } else if (element.hasClass("validateBeforeRedirect")) {
                $("<div class='col-12 col-md-8 offset-md-3 ec'></div>").append(error).insertAfter(element.parent());
            } else if (element.hasClass("payment-profile-radio") || element.hasClass("payment_method-radio")) {
                $("<div class='col-12 col-md-8 offset-md-3 ec'></div>").append(error).insertAfter(element.parent().parent().parent().parent());
            } else if (element[0].name === "VariationCode") {
                $("<div class='col-12 ec'></div>").append(error).insertAfter(element.parent().parent().parent().parent());
            } else if ($(element).is(":checkbox")) {
                const fieldSet$ = $(element).parents("fieldset");
                if (fieldSet$.length && fieldSet$.hasClass("display-status-border")) {
                    fieldSet$.addClass("input-validation-error");
                    error.insertAfter(fieldSet$);
                } else {
                    error.insertAfter(element);
                    if ($(element).parent().parent().hasClass("offset-md-4")) { // Modal in VPP ProductSelection SM
                        $("<div class='col-12 col-md-8 offset-md-4'></div>").append(error).insertAfter(element.parent().parent().parent());
                    } else if ($(element).parent().parent().hasClass("col-12")) {
                        $("<div class='col-12'></div>").append(error).insertAfter(element.parent().parent());
                    } else {
                        $("<div class='col-12 col-md-8 offset-md-3 ec'></div>").append(error).insertAfter(element.parent().parent().parent());
                    }
                }
            } else {
                error.insertAfter(element);
            }
        },
        success: (label: JQuery/*, validatedInput: HTMLElement*/) => {
            label.parent().find(".display-status-border").removeClass("input-validation-error");
            label.removeClass("input-validation-error");
            label.remove();
        },
        showErrors: function (errorMap: JQueryValidation.ErrorDictionary, errorList: JQueryValidation.ErrorListItem[]) {
            if (this.numberOfInvalids() > 0) {
                $.each(errorList, function (index, item) {
                    const placeholder = "{{FELDNAME}}";
                    const domElement = item["element"];

                    if (String(item.message).indexOf(placeholder) !== -1) {
                        const labelElements = $("label[for=" + domElement.id + "]");
                        let messageWithReplacement = "";

                        if (labelElements.length > 0) { // is error for JS validated field
                            messageWithReplacement = item.message.replace(placeholder, labelElements[0].innerText);
                        } else { // is error for Unobtrusive validated field
                            const labelText = domElement.parentElement.previousElementSibling ? (<HTMLElement>domElement.parentElement.previousElementSibling).innerText : undefined;
                            if (labelText) {
                                messageWithReplacement = item.message.replace(placeholder, labelText);
                            }
                        }
                        item.message = messageWithReplacement;
                        item.element.outerHTML.replace(item.message, messageWithReplacement);
                    }
                });
            }
            this.defaultShowErrors();
        },
        invalidHandler: () => {
            setTimeout(() => App.Common.Functions.scrollToError(), 10);
        },
    }

    static init(): void {
        // Validator Settings
        $.validator.setDefaults(Validation.ValidatorSettings);

        // Validator unobtrusive global settings (Notice: must be defined before including unobtrusive.js)
        // override jQuery unobtrusive validator settings
        if (typeof $.validator.unobtrusive !== "undefined") {
            (<UnobtrusiveValidationValidator>$.validator.unobtrusive).options = Validation.ValidatorSettings;
        }

        $.validator.addMethod("hasUnicodeNumberSpaceMinus", function (value, element) {
            return this.optional(element) || new RegExp("^[\\u00C0-\\u017Fa-zA-Z0-9\\s\\ -]*$").test(value);
        }, "Just Unicodes Space and Minus");

        $.validator.addMethod("isAtLeastOneCheckboxSelected", function (/*value, element*/) {
            /* Check if at least one checkbox is checked */
            return ($("#vignette").is(":checked") || $("#sondermaut").is(":checked"));
        });


        $.validator.addMethod("dateFormat", function (value, element) {
            let check = false;
            const re = /^\d{2}\.\d{2}\.\d{4}$/;
            if (re.test(value)) {
                const adata = value.split(".");
                const dd = parseInt(adata[0], 10);
                const mm = parseInt(adata[1], 10);
                const yyyy = parseInt(adata[2], 10);
                const xdata = new Date(yyyy, mm - 1, dd);
                if (xdata.getFullYear() === yyyy && xdata.getMonth() === mm - 1 && xdata.getDate() === dd) {
                    check = true;
                }
                else {
                    check = false;
                }
            } else {
                check = false;
            }
            return this.optional(element) || check;
        }, function (/*params, element*/) {
            return Resources.ErrorMessages.dateFormatNotValid;
        });

        $.validator.addMethod("meetsRegEx", function (/*value, element*/) {
            function showSpecialLicensePlateCheckbox(result: AjaxServiceResponse<IValidatePlateResponseData>) {
                if (result.Status === App.Common.Constants.Api.ResponseMessage.Success) {
                    if (result.Data != null) {
                        valid = result.Data.IsValid;
                        if (valid && result.Data.RegexType == LicensePlateRegexType.Special) {
                            $("#licenseplatestatus").val("isSpecial");
                            $("#div-speciallicenseplate").show();
                            Functions.LicensePlate.ShowInfoText();
                            if (!$("#check-speciallicenseplate").is(":checked")) {
                                valid = true;
                            }
                            Functions.setFieldRequired("check-speciallicenseplate", true);


                            showLicensePlatePreview(
                                result.Data.GraphicRegistrationNumberImageUrl,
                                result.Data.PreviewBackgroundImageUrl,
                                result.Data.TextBefore,
                                result.Data.TextAfter);


                        } else if (valid && result.Data.RegexType == LicensePlateRegexType.Standard) {
                            $("#licenseplatestatus").val("isNormal");
                            Functions.setFieldRequired("check-speciallicenseplate", false);
                            $("#div-speciallicenseplate").hide();

                            showLicensePlatePreview(
                                result.Data.GraphicRegistrationNumberImageUrl,
                                result.Data.PreviewBackgroundImageUrl,
                                result.Data.TextBefore,
                                result.Data.TextAfter);
                        } else {
                            Validation.errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegEx;
                            hideLicensePlatePreview();
                        }
                    } else {
                        valid = false;
                        Validation.errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegEx;
                        hideLicensePlatePreview();
                    }
                }
            }
            function hideLicensePlatePreview() {
                $("#glp-bgimage").css("background-image", "");
                $("#lp-img").css("background-image", "");
                $("#lp-code").text("");
                $("#lp-number").text("");
            }

            function showLicensePlatePreview(bgFrameUrl: string, previewBackgroundImageUrl: string, textBefore: string, textAfter: string) {
                if (bgFrameUrl != null || previewBackgroundImageUrl != null) {
                    $("#glp-container").show();
                }
                if (bgFrameUrl != null) {
                    $("#glp-bgimage").css("background-image", "url(" + bgFrameUrl + ")");
                }
                if (previewBackgroundImageUrl != null) {
                    $("#lp-img").css("background-image", "url(" + previewBackgroundImageUrl + ")");
                }
                $("#lp-code").text(textBefore);
                $("#lp-number").text(textAfter);
            }
            function meetsSpecialLicensePlateRegEx(result: AjaxServiceResponse<IValidatePlateResponseData>) {
                if (result.Status === App.Common.Constants.Api.ResponseMessage.Success) {
                    Validation.errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegEx;
                    valid = result.Data.IsValid;
                    showSpecialLicensePlateCheckbox(result);
                }
            }

            /* Replace lowercase with uppercase letters and minus with hyphen */
            const licenseplate = (<string>$("#licenseplate").val()).toUpperCase().replace(/\\–/g, "-").replace(/ /g, "") || "";
            const countrycode = <string>$("#licenseplate_country").val() || "";
            let valid = false;

            const data: IValidateLicensePlateData = {
                __RequestVerificationToken: (<HTMLFormElement>document.querySelector("input[name=__RequestVerificationToken]")).value,
                licensePlate: licenseplate,
                countryCode: countrycode,
                isZba: false
            }

            $("#licenseplate").val(licenseplate);
            /* we have to validate every kind of license plate, even special ones */
            $("#licenseplatestatus").val("isInvalid");

            if (JSON.stringify(data) === JSON.stringify(Validation.lastData)) {
                // call function with oldResult
                meetsSpecialLicensePlateRegEx(Validation.lastResult);
            } else if (licenseplate !== "" && countrycode !== "") {
                //ajax call and call function
                $.ajax({
                    url: Resources.Apis.validateLicensePlateURL,
                    type: "POST",
                    async: false,
                    data: data,
                    success: (result: AjaxServiceResponse<IValidatePlateResponseData>) => {
                        Validation.lastData = data;
                        Validation.lastResult = result;
                        meetsSpecialLicensePlateRegEx(result);
                    },
                    error: (error) => {
                        const errorString = JSON.stringify(error);
                        App.Common.Logging.logWarning(`${Resources.Apis.validateLicensePlateURL} - Error: "${errorString}"`);
                        Validation.errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegExNoAnswer;
                    }
                });
            }
            return valid;
        }, () => {
            return Validation.errorMessageRegEx ?? Resources.ErrorMessages.errorLicensePlateRegEx;
        });


        $.validator.addMethod("meetsRegExEvidence", function (/*value, element*/) {
            const licenseplate = (<string>$("#evidence-widget-licenseplate").val()).toUpperCase().replace(/\\–/g, "-").replace(/ /g, "") || "";
            const countrycode = <string>$("#evidence-widget-nationality").val() || "";

            const data: IValidateLicensePlateData = {
                __RequestVerificationToken: (<HTMLFormElement>document.querySelector("input[name=__RequestVerificationToken]")).value,
                licensePlate: licenseplate,
                countryCode: countrycode,
                isZba: false
            }
            let valid = false;

            $.ajax({
                url: Resources.Apis.validateLicensePlateURL,
                type: "POST",
                async: false,
                data: data,
                success: function (result: AjaxServiceResponse<IValidatePlateResponseData>) {
                    Validation.lastData = data;
                    Validation.lastResult = result;
                    if (result.Status === App.Common.Constants.Api.ResponseMessage.Success) {
                        if (result.Data != null) {
                            valid = result.Data.IsValid;
                        } else {
                            valid = false;
                            Validation.errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegEx;
                        }

                    }
                },
                error: (error) => {
                    const errorString = JSON.stringify(error);
                    App.Common.Logging.logWarning(`${Resources.Apis.validateLicensePlateURL} - Error: "${errorString}"`);
                    Validation.errorMessageRegEx = Resources.ErrorMessages.errorLicensePlateRegExNoAnswer;
                }
            });
            return valid;
        }, function () {
            return Validation.errorMessageRegEx ?? Resources.ErrorMessages.errorLicensePlateRegEx;
        });

        $.validator.addMethod("telRegex", function (value/*, element*/) {
            if (value.length) {
                return /^[+]?[\d ]{1,25}$/im.test(value);
            }
            return true;
        });

        $.validator.addMethod("fitsLength", function (/*value, element*/) {
            /* Replace minus with empty value */
            const licenseplate = (<string>$("#licenseplate").val())?.toString().replace(/–/g, "").replace(/ /g, "") || "";
            const length = licenseplate.length;
            let valid = false;
            // hideLicensePlatePreview();
            /* validate only if standard licence plate */
            if (length >= 2 && length <= 10) {
                valid = true;
            }
            return valid;
        }, function (/*params, element*/) {
            return Resources.ErrorMessages.licenceplateLength;
        });

        $.validator.addMethod("emailRegex", function (value/*, element*/) {
            // eslint-disable-next-line no-useless-escape, no-control-regex
            return /^(?:[a-zA-Z0-9!#$%&'*+=?^_`\{\|\}~\-]+(?:\.[a-zA-Z0-9!#$%&'*+=?^_`\{\|\}~\-]+)*|""(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*"")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9\-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/.test(value);
        }, () => {
            return Resources.ErrorMessages.emailregexnotvalid;
        });

        $.validator.addMethod("equalToIgnoreCase", function (value, element, param) {
            return this.optional(element) ||
                value.toLowerCase() === (<string>$(param).val()).toLowerCase();
        });

        $.validator.addMethod("requiredDepends",
            function (value, element) {
                const dependsFieldChecked = $("#" + $(element).data("depends") + ":checked").length > 0;
                return !dependsFieldChecked ||
                    jQuery.validator.methods.required.call(this, value, element);
            },
            function (/*params, element*/) {
                return Resources.ErrorMessages.fieldRequiredError;
            });
    }
}